import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EducationLeftPanel from "./EducationLeftPanel";
import EducationRightPanel from "./EducationRightPanel";
import Button from "../ui/Button";
import { ButtonVariant } from "../../types/constants";
import { useBreakpoint } from "../../custom-hooks/useBreakpoint";

export default function Education() {
    const { t } = useTranslation();
    const { isTablet } = useBreakpoint();
    const navigate = useNavigate();

    return (
        <section className={isTablet ? "w-screen -mx-[40px] px-[40px] relative" : "relative"}>
            <div
                className={`w-full max-w-[1280px] mx-auto ${isTablet ? "grid grid-cols-1 gap-[42px]" : "flex-col flex lap:flex-row gap-[32px] lap:gap-[20px]"}`}
            >
                <EducationLeftPanel />
                <EducationRightPanel />
            </div>
            <div className="mt-[32px] hidden sm:flex lap:hidden justify-start">
                <Button
                    text={t("buttons.moreMaterials")}
                    variant={ButtonVariant.PRIMARY}
                    onClick={() => navigate("/educational-materials")}
                />
            </div>
        </section>
    );
}
